import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from '@quorum/api';
import { catchError, map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { InspectionService } from '@quorum/xsr-legacy-vip/services';

@Component({
  selector: 'svc-tech-landing',
  templateUrl: './tech-landing.component.html',
  styleUrls: ['./tech-landing.component.scss'],
})
export class TechLandingComponent implements OnInit {
  workOrderForm: FormGroup = this.formBuilder.group({
    workOrderId: null,
  });
  searchLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private inspectionService: InspectionService
  ) {}

  ngOnInit() {}

  search(formValue: any) {
    if (formValue.workOrderId !== null) {
      this.searchLoading$.next(true);
      this.apiService
        .get(`/v/1/fixed-operations/work-orders/${formValue.workOrderId}`)
        .pipe(
          catchError(() => {
            this.workOrderForm.get('workOrderId').setErrors({ invalidWorkOrderId: true });
            this.searchLoading$.next(false);
            return EMPTY;
          }),
          map((workOrder) => {
            this.searchLoading$.next(false);
            if (workOrder != null) {
              this.inspectionService.triggerInspectionLogic.next(workOrder.id);

              //Check router state url to see if we navigated to this page or using it as component in html
              if (this.router.routerState.snapshot.url === '/tech') {
                this.router.navigate([`inspection`], {
                  relativeTo: this.route,
                  queryParams: { workOrderId: workOrder.id },
                });
              } else {
                this.router.navigate([`tech/inspection`], {
                  relativeTo: this.route,
                  queryParams: { workOrderId: workOrder.id },
                });
              }
            } else {
              this.workOrderForm.get('workOrderId').setErrors({ invalidWorkOrderId: true });
            }
          })
        )
        .subscribe();
    }
  }
}
